import React from "react";
import { Field, useFormikContext } from "formik";
import { formatCNPJOrCPF, cleanDocument } from "@utils/cnpj";

interface MaskedInputProps {
  name: string;
  placeholder: string;
  className?: string;
}

const MaskedCpfCnpjField: React.FC<MaskedInputProps> = ({
  name,
  placeholder,
  className,
}) => {
  const { values, setFieldValue } = useFormikContext<Record<string, string>>();
  const value = values[name] || "";

  return (
    <Field
      className={className}
      name={name}
      type="text"
      placeholder={placeholder}
      value={formatCNPJOrCPF(value)}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = cleanDocument(e.target.value);
        if (raw.length <= 14) {
          setFieldValue(name, raw);
        }
      }}
      maxLength={18}
    />
  );
};

export default MaskedCpfCnpjField;
